import * as React from 'react';

import { IDisclaimer } from '../../infrastructure/interfaces';
import Button from '../Button';
import {DropdownMenu} from '../DropdownMenu';
import { IDropdownMenuOption } from '../DropdownMenu/DropdownMenu';
import { Modal } from '../Modal';
import MarkdownTextArea from "../MarkdownTextArea"

export interface DisclaimerEditorProps {
  show: any;
  onClose: any;
  disclaimer?: IDisclaimer;
  onSave(disclaimer: IDisclaimer): void;
}

export interface DisclaimerEditorState {
  editedDisclaimer: IDisclaimer;
  hasRequiredFields: boolean;
}

const placeholderDisclaimer = {
  document_type: "Bulletin",
  value: "*",
  description: "",
};

export default class DisclaimerEditorModal extends React.Component<DisclaimerEditorProps, DisclaimerEditorState> {

  constructor(props: DisclaimerEditorProps) {
    super(props);
    this.state = {
      editedDisclaimer: (this.props.disclaimer) ? this.props.disclaimer : placeholderDisclaimer,
      hasRequiredFields: (this.props.disclaimer) ? true : false
    };
  }

  componentWillReceiveProps(nextProps: DisclaimerEditorProps) {
    if (nextProps.disclaimer && (nextProps.disclaimer !== this.props.disclaimer)) {
      this.setState({editedDisclaimer: nextProps.disclaimer }, () => this.hasValidFields());
    }
  }

  handleInputGroupChange(newDescription: string) {
    this.setState({
      editedDisclaimer: {
        id: this.state.editedDisclaimer.id,
        document_type: this.state.editedDisclaimer.document_type,
        value: this.state.editedDisclaimer.value,
        description: newDescription,
      }
    }, () => this.hasValidFields());
  }

  handleInputTypeChange(newType: string) {
      //The rest of the app is looking for document_type == "Brochure" for a disclaimer, so
      //we toggle here to show the name we want, but able to use on products, etc...
      if (newType == "Quad Fold") {
          newType = "Brochure"
      }
    this.setState({
      editedDisclaimer: {
        id: this.state.editedDisclaimer.id,
        document_type: newType,
        value: this.state.editedDisclaimer.value,
        description: this.state.editedDisclaimer.description,
      }
    }, () => this.hasValidFields());
  }

  hasValidFields() {
    const hasValidText = (this.state.editedDisclaimer.description.length > 1);
    this.setState({ hasRequiredFields: hasValidText });
  }

  closeModal() {
      this.setState({
        editedDisclaimer: placeholderDisclaimer,
      });
      this.props.onClose();
  }

  render() {

    var productTypeOptionsList: IDropdownMenuOption[] = [{
      title:"Quad Fold",
      onClick: () => {
        this.handleInputTypeChange("Quad Fold");
      }
    },
    {
      title:"Bulletin",
      onClick: () => {
        this.handleInputTypeChange("Bulletin");
      }
    },
    {
      title:"Catalog",
      onClick: () => {
        this.handleInputTypeChange("Catalog");
      }
    }
  ];
    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <Modal.Title>
                    <h5>
                        {this.props.disclaimer ? "Edit Disclaimer" : 'Create Disclaimer'}
                    </h5>
                </Modal.Title>
                <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="editDisclaimerContainer">
                    <div className="editDisclaimerInputContainer">
                        <div>
                            <b>Description:  </b>
                        </div>
                        <div>
                            <MarkdownTextArea
                                textValue={this.state.editedDisclaimer.description}
                                onChange={(text: string) => this.handleInputGroupChange(text)}
                            />
                        </div>
                    </div>
                    <div className="editDisclaimerInputContainer">
                        <div>
                            <b>Product Type:  </b>
                        </div>
                        <div>
                            <DropdownMenu
                                title={this.state.editedDisclaimer.document_type == "Brochure" ? "Quad Fold" : this.state.editedDisclaimer.document_type}
                                options={productTypeOptionsList}
                                extraWide={true}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                        this.props.onSave(this.state.editedDisclaimer);
                        this.setState({
                          editedDisclaimer: placeholderDisclaimer,
                        });
                    }}
                >
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/DisclaimerEditorModal.tsx